import(/* webpackMode: "eager" */ "/codebuild/output/src207228893/src/apps/nextjs-bigcommerce/app/(storefront)/error.tsx");
